import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { useLanguage } from '../hooks/useLanguage';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function OurToolsPage() {
  const {
    t,
    setLocale,
    direction
  } = useLanguage();
  const location = useLocation();
  const {
    ref: heroRef,
    isVisible: heroVisible
  } = useScrollReveal();
  const {
    ref: cardsRef,
    isVisible: cardsVisible
  } = useScrollReveal();
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useScrollReveal();
  useEffect(() => {
    if (location.pathname.startsWith('/ar')) {
      setLocale('ar');
    } else {
      setLocale('en');
    }
    window.scrollTo(0, 0);
  }, [location.pathname, setLocale]);
  const tools = [{
    title: t('ourToolsPage.tools.cms.title'),
    description: t('ourToolsPage.tools.cms.description')
  }, {
    title: t('ourToolsPage.tools.dataNavigator.title'),
    description: t('ourToolsPage.tools.dataNavigator.description')
  }, {
    title: t('ourToolsPage.tools.apiIntegration.title'),
    description: t('ourToolsPage.tools.apiIntegration.description')
  }, {
    title: t('ourToolsPage.tools.dataReplication.title'),
    description: t('ourToolsPage.tools.dataReplication.description')
  }];
  return <div className="min-h-screen w-full bg-white text-slate-900" dir={direction} data-id="element-990">
      <Header variant="dark" data-id="element-991" />

      <main data-id="element-992">
        {/* White header background spacer */}
        <div className="bg-white h-20" data-id="element-993" />

        {/* Hero Banner - compact gradient bar */}
        <section className="gradient-dark-horizontal py-16 md:py-20 relative overflow-hidden" ref={heroRef} aria-label="Our Tools Hero" data-id="element-994">
          {/* Top-left decorative SVG */}
          <img src="https://cdn.magicpatterns.com/uploads/oSPxnKHLzspYqMxuH2SAJd/inner-top-left.svg" alt="" role="presentation" aria-hidden="true" className="absolute top-0 left-0 w-[200px] md:w-[300px] h-auto pointer-events-none opacity-20" data-id="element-995" />

          <div className="container mx-auto px-6 md:px-12" data-id="element-996">
            <h1 className={`text-white font-bold leading-[1.1] mb-4 uppercase text-[32px] md:text-[44px] lg:text-[50px] reveal-hidden ${heroVisible ? 'animate-fade-up' : ''}`} data-id="element-997">
              {t('ourToolsPage.hero.title')}
            </h1>
            <p className={`text-white/80 text-base md:text-lg whitespace-pre-line leading-relaxed reveal-hidden ${heroVisible ? 'animate-fade-up delay-200' : ''}`} data-id="element-998">
              {t('ourToolsPage.hero.subtitle')}
            </p>
          </div>
        </section>

        {/* Tools Cards Section - 2x2 grid */}
        <section className="py-20 md:py-32 bg-white relative overflow-hidden" ref={cardsRef} aria-label="Our Tools" data-id="element-999">
          <div className="container mx-auto px-6 md:px-12" data-id="element-1000">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1001">
              {tools.map((tool, index) => <div key={index} className={`relative overflow-hidden bg-white border border-[#E6E6E6] rounded-lg p-8 md:p-10 min-h-[220px] reveal-hidden ${cardsVisible ? 'animate-fade-up' : ''}`} style={{
              animationDelay: `${index * 100}ms`
            }} data-id="element-1002">
                  {/* Decorative SVG - bottom right of each card */}
                  <img src="https://cdn.magicpatterns.com/uploads/cReFqSbgbGUsvkVjkEFgvx/other-services.svg" alt="" role="presentation" aria-hidden="true" className="absolute bottom-0 right-0 pointer-events-none h-[60%] md:h-[90%] w-auto" style={{
                marginBottom: '-7px',
                marginRight: '-1px'
              }} data-id="element-1003" />

                  <div className="relative z-10 max-w-md" data-id="element-1004">
                    <h3 className="text-[#061D76] font-bold text-lg md:text-xl mb-4 leading-tight" data-id="element-1005">
                      {tool.title}
                    </h3>
                    <p className="text-[#061D76]/70 text-sm md:text-base leading-relaxed" data-id="element-1006">
                      {tool.description}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="relative py-24 text-white overflow-hidden" dir={direction} ref={ctaRef} aria-label="Call to Action" data-id="element-1007">
          <div className="absolute inset-0 bg-cover bg-center" role="presentation" aria-hidden="true" style={{
          backgroundImage: "url('https://cdn.magicpatterns.com/uploads/aNushftuwBdDBhG34PgQWF/Trusted.jpg')"
        }} data-id="element-1008" />

          <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-1009">
            <div data-id="element-1010">
              <h2 className={`text-4xl md:text-5xl font-bold mb-6 whitespace-pre-line reveal-hidden ${ctaVisible ? 'animate-fade-left' : ''}`} data-id="element-1011">
                {t('aboutPage.cta.heading')}
              </h2>
              <p className={`text-white max-w-[950px] text-lg mb-8 leading-relaxed reveal-hidden ${ctaVisible ? 'animate-fade-left delay-200' : ''}`} data-id="element-1012">
                {t('aboutPage.cta.description')}
              </p>
              <button className={`btn-primary reveal-hidden ${ctaVisible ? 'animate-fade-up delay-400' : ''}`} data-id="element-1013">
                {t('aboutPage.cta.button')}
              </button>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-1014" />
    </div>;
}